module.exports = __webpack_public_path__ + "static/media/bg.eceb6cf6.jpg";